import React from 'react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {Text, Flex} from '@priority-software/priority-style-react';
import {PRIORITY_FIELD, COMPLETE_BY, DETAILS} from '../../consts';
import {getIsOverdue} from '../../utils';
import styles from '../../styles/ToDoListConent.module.scss';
import {Record} from '../../../../stores/Form/Record';
import {Tooltip} from '../../../../components/Common/Tooltip';
import {isDate} from '../../../Form/utils/date';
import {TooltipPosition} from '../../../../components/Common/Tooltip/types';

type FieldValueProps = {
    record: Record;
    column: priority.netitems.form.IColumn;
    tooltipPosition: TooltipPosition;
};

export const FieldValue = ({record, column, tooltipPosition}: FieldValueProps) => {
    const hasTooltip = column.Name === DETAILS;
    const value = record.getField(column.ID as number)?.origValue?.toString();
    const isDateField = isDate(column.Type);
    const shouldCalcIsOverdue = value && isDateField && column.Name === COMPLETE_BY;
    const isOverdue = shouldCalcIsOverdue && getIsOverdue({record, column});
    const colClass = isDateField ? (isOverdue ? styles.overdue : '') : styles.fieldTxtVal;

    const getDefaultValue = (colName: string) => {
        return colName === PRIORITY_FIELD ? '0' : '-';
    };

    return (
        <div className={styles.mainColumn}>
            <Flex>
                {hasTooltip && value ? (
                    <Tooltip tooltip={value} position={tooltipPosition}>
                        <Text
                            skin="paragraph-2"
                            textColor="primary-700"
                            componentClasses={colClass}
                        >
                            {value || getDefaultValue(column.Name)}
                        </Text>
                    </Tooltip>
                ) : (
                    <Text skin="paragraph-2" textColor="primary-700" componentClasses={colClass}>
                        {value || getDefaultValue(column.Name)}
                    </Text>
                )}
            </Flex>
        </div>
    );
};
